import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {FaEdit, FaCog} from "react-icons/fa";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {Dropdown} from "react-bootstrap";

class ListUserComponent extends Component {

    render() {
        return (
            <tr>
                <td>
                    <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.user.id}>{this.props.user.name}</Link>
                </td>
                <td>
                    <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.user.id}>{this.props.user.email}</Link>
                </td>
                <td>
                    {this.props.user.phone}
                </td>
                <td>
                    {
                        this.props.user.group_user ? (
                            <>{ this.props.user.group_user.name }</>
                        ) : (
                            <>Cơ bản</>
                        )
                    }
                </td>
                <td>
                    {this.props.user.sdtk}
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chỉnh sửa số dư tài khoản
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <span className="edit-credit"
                              onClick={ () => this.props.showModal( this.props.user, 'editCredit', this.props.changeKey ) }
                        >
                            <FaEdit />
                        </span>
                    </OverlayTrigger>
                </td>
                <td>
                    {this.props.user.total}
                </td>
                <td>
                    {this.props.user.total_total_expenses}
                </td>
                <td>
                    {this.props.user.role}
                </td>
                <td>
                    {this.props.user.dateCreate}
                </td>
                <td>
                    <Link to={'/admin/khach-hang/chinh-sua-khach-hang/' + this.props.user.id}>
                        <button type="button" className="btn btn-warning btn-sm mr-1 text-light">
                            <FaEdit />
                        </button>
                    </Link>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Hành động
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Dropdown className="btn mr-1 p-0">
                            <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn-sm">
                                <FaCog />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.user, 'loginAsUser', this.props.changeKey ) }>Login as user</Dropdown.Item>
                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.user, 'historyPayment', this.props.changeKey ) }>Lịch sử thanh toán</Dropdown.Item>
                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.user, 'historyLog', this.props.changeKey ) }>Lịch sử hoạt động</Dropdown.Item>
                                <Dropdown.Item onClick={ () => this.props.showModal( this.props.user, 'delete', this.props.changeKey ) }>Xóa</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </OverlayTrigger>
                    {/*<button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.user, 'delete', this.props.changeKey ) }>*/}
                    {/*    <FaTrash />*/}
                    {/*</button>*/}
                </td>
            </tr>
        );
    }
}

export default ListUserComponent;